// frontend/src/landing/sections/FooterSection.tsx
export default function FooterSection() {
  return (
    <footer className="zg-footer">
      <div className="zg-container zg-footer-inner">
        <div>
          © 2026{" "}
          <a
            className="zg-nav-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://data-science.ai"
          >
            data-science.ai
          </a>
        </div>

        <div className="zg-footer-links">
          <a className="zg-nav-link" href="#top">
            nach oben
          </a>

          <a
            className="zg-nav-link"
            href="mailto:info@zeit-geist.ai"
          >
            Mail schreiben
          </a>
        </div>
      </div>
    </footer>
  );
}